import {
  Dialog,
  DialogTitle,
  DialogActions,
} from "V2.0/common/dialog";
import { Button } from "V2.0/common/button";
import { useState } from "react";
import { message } from "antd";
import { showErrorToast } from "V2.0/utils";

export default PipelineV2RunDelete;

interface PipelineV2RunDeleteProps {
  pipelineRun: any;
  onClose: () => void;
  onDeletePipelineRun: (pipelineRunId: string, lifecycleCbs) => void;
}

function PipelineV2RunDelete(props: PipelineV2RunDeleteProps) {
  const { pipelineRun, onClose, onDeletePipelineRun } = props;

  const [loading, setLoading] = useState<boolean>(false);

  const handleDelete = () => {
    function init() {
      setLoading(true);
      message.loading("Deleting Pipeline Run");
    }

    function success() {
      setLoading(false);
      message.destroy();
      message.success("Pipeline Run Deleted");
      onClose();
    }

    function error(e) {
      setLoading(false);
      message.destroy();
      showErrorToast(e, "Failed to delete pipeline run");
    }

    onDeletePipelineRun(pipelineRun._id, { init, success, error });
  };

  return (
    <Dialog
      open={true}
      onClose={onClose}
    >
      <DialogTitle>Delete Pipeline Run?</DialogTitle>
      <DialogActions>
        <Button
          outline
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button
          color="red"
          loading={loading}
          disabled={loading}
          onClick={handleDelete}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}
